import { MapPin, Store, Warehouse } from 'lucide-react';
import type { CSSProperties, ComponentType, ElementType } from 'react';

import { SITE_TYPE } from '@klareospace/pharos-lib-types';
import type { SiteType } from '@klareospace/pharos-lib-types';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface SiteIconProps {
  className?: string;
  style?: CSSProperties;
}

/**
 * Maps each SiteType value to its corresponding Lucide icon component.
 *
 * Single source of truth — replaces the two separate mappings that existed in:
 * - apps/pharos-ui-frontoffice/src/features/settings/sites/utils/site-type-icon.tsx
 * - apps/pharos-ui-frontoffice/src/features/main-selector/utils/site-icon-map.ts
 */
export const SITE_TYPE_ICON_MAP: Record<SiteType, ComponentType<SiteIconProps>> = {
  [SITE_TYPE.RELAY]: MapPin,
  [SITE_TYPE.SHOP]: Store,
  [SITE_TYPE.WAREHOUSE]: Warehouse,
};

/**
 * Resolve the icon component for a given SiteType, falling back to `fallback`
 * when the type is undefined or not present in SITE_TYPE_ICON_MAP.
 *
 * @example resolveSiteTypeIcon(SITE_TYPE.SHOP, Building2)  // Store
 * @example resolveSiteTypeIcon(undefined, Warehouse)        // Warehouse
 */
export function resolveSiteTypeIcon(type: SiteType | undefined, fallback: ElementType): ElementType {
  if (type === undefined) return fallback;
  return (SITE_TYPE_ICON_MAP[type] as ElementType | undefined) ?? fallback;
}
